
import { Component, Vue } from "vue-property-decorator";
import { PFormInputText, PDropDownContainer, PButton, SelectType, PFormSelect } from "@/common/components";
import { PRow } from "@/common/components/look/PRow";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { EventBus } from "@/event-bus";

@Component({
  name: "support-drop-down-device-id",
  components: {
    PRow,
    PButton,
    PFormInputText,
    PDropDownContainer,
    PFormSelect,
    PIcon,
  },
})
export class SupportDropDownDeviceId extends Vue {
  filterProperties: SelectType[] = [];
  selectItemFilterPropertie = "";
  link = "link";

  async created(): Promise<void> {
    const result1: string[] = await this.$services.supportTransaction.fetchDeviceIds();
    result1.forEach((it: string) => this.filterProperties.push({ text: it.toString(), value: it.toString() }));
  }

  setItem(item: string): void {
    this.selectItemFilterPropertie = item;
  }

  reset(): void {
    this.selectItemFilterPropertie = this.$t("support_panel.dropdown.placeholder_device_id").toString();
    EventBus.$emit("clear-filter-by-device_id", this.selectItemFilterPropertie);
    alert("Filtro reseteado");
  }

  filter(): void {
    EventBus.$emit("filter-by-device-id-support", { deviceId: this.selectItemFilterPropertie });
    alert("Filtro aplicado");
  }
}
export default SupportDropDownDeviceId;
